import { useMutation } from '@tanstack/react-query';
import { patchCompanyTwo } from 'api/resources/companyTwo';

export const usePatchCompanyTwo = () => {
	return useMutation(patchCompanyTwo);
};
